import React from "react";
import { Typography, Grid, Box, Container, Button } from "@mui/material";

export default function Main() {
  return (
    <div className="main_div">
      <Container>
        <Grid container>
          <Grid item xs={12} sm={12} md={6} lg={5.5} mt={20}>
            <Typography className="main_typo1">
              We offer freelancers and customers a virtual way to get paid
              securely through escrow payment transfers.
            </Typography>

            <Typography className="main_typo2" mt={5}>
              Get paid securely through escrow payment transfers.
            </Typography>
            <Button className="main_btn" sx={{ mt: 5 }}>
              Get Started
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
